import { Box, MarkerLocationIcon } from '@deckee/deck-hand';
import PropTypes from 'prop-types';
import React from 'react';
import { connect, useSelector } from 'react-redux';
import { captureEvent } from '../../../services/event-capture';
import {
  mapBaseLayerDefinitions,
  updateBaseLayer,
} from '../../../services/map-style';
import {
  setMapOptions,
  updateSelectedBaseMapLayer,
  updateSelectedLayerTypes,
} from '../../../services/store/modules/app-controls';
import {
  getSelectedLayers,
  switchLayer,
} from '../../../services/store/modules/map-settings';
import MapSettingsContainerView from './components/MapSettingsContainerView';
import usePaywall from '../../hooks/use-paywall';
import { selectHasCurrentMemberActiveSubscription } from '../../../services/store/modules/backend-service';

const CircleWrapper = ({ children, bg, iconSize = 24 }) => (
  <Box
    width={40}
    height={40}
    display="flex"
    flex="0 0 auto"
    justifyContent="center"
    alignItems="center"
    borderRadius="50%"
    bg={bg}
  >
    <Box
      width={iconSize}
      height={iconSize}
      flex={`0 0 ${iconSize}px`}
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      {children}
    </Box>
  </Box>
);

export const MarkerGroupIcon = ({ bg, icon }) => (
  <CircleWrapper
    bg={bg}
    display="flex"
    alignItems="center"
    justifyContent="center"
  >
    {icon || <MarkerLocationIcon color="white" />}
  </CircleWrapper>
);

// eslint-disable-next-line no-warning-comments
// TODO: This is only hard coded as a temp. measure
const mapSettingsMarkerGroups = [
  {
    displayName: 'Marine points of interest',
    url: '/maps/settings/map/marine-points-of-interest',
    indicatorIcon: 'sub-level',
    menuIconNode: <MarkerGroupIcon bg="#139ECA" />,
  },
  {
    displayName: 'Marine facilities',
    url: '/maps/settings/map/marine-facilities',
    indicatorIcon: 'sub-level',
    menuIconNode: <MarkerGroupIcon bg="#56AC5C" />,
  },
  {
    displayName: 'General services',
    url: '/maps/settings/map/general-services',
    indicatorIcon: 'sub-level',
    menuIconNode: <MarkerGroupIcon bg="#906BD9" />,
  },
  {
    displayName: 'Safety',
    url: '/maps/settings/map/safety',
    indicatorIcon: 'sub-level',
    menuIconNode: <MarkerGroupIcon bg="#E28D18" />,
  },
];

const MapSettingsPage = (props) => {
  const { selectedLayerTypes, selectedBaseMapLayer, dispatch } = props;
  const BASE_MAP_LAYER_DEFINITIONS = mapBaseLayerDefinitions;

  const { presentPaywall } = usePaywall('Bathymetry');
  const hasActiveSubscription = useSelector(
    selectHasCurrentMemberActiveSubscription,
  );
  const handleUpdateSelectedBaseMapLayer = (baseMapLayerToSelect) => {
    captureEvent({
      type: 'map: change base layer',
      payload: {
        baseMapLayerToSelect,
      },
    });
    updateBaseLayer(baseMapLayerToSelect);
  };

  const toggleSelectedLayerType = (layerName) => {
    let layerIsOn = false;

    const subscriptionOnlyLayers = ['wmsbathymetry'];
    if (subscriptionOnlyLayers.includes(layerName) && !hasActiveSubscription) {
      presentPaywall();
    } else {
      if (selectedLayerTypes.indexOf(layerName) !== -1) {
        // Turn option OFF
      } else {
        // Turn option ON

        layerIsOn = true;
      }
      dispatch(switchLayer({ name: layerName, enabled: layerIsOn }));
    }
  };

  return (
    <MapSettingsContainerView
      toggleSelectedLayerType={toggleSelectedLayerType}
      selectedLayerTypes={selectedLayerTypes}
      BASE_MAP_LAYER_DEFINITIONS={BASE_MAP_LAYER_DEFINITIONS}
      handleUpdateSelectedBaseMapLayer={handleUpdateSelectedBaseMapLayer}
      selectedBaseMapLayer={selectedBaseMapLayer}
      mapSettingsMarkerGroups={mapSettingsMarkerGroups}
    />
  );
};

MapSettingsPage.propTypes = {
  selectedLayerTypes: PropTypes.arrayOf(PropTypes.string),
  selectedBaseMapLayer: PropTypes.string,
};

MapSettingsPage.defaultProps = {
  selectedLayerTypes: [],
  selectedBaseMapLayer: null,
};

const mapStateToProps = (state) => ({
  selectedBaseMapLayer: state.appControls.selectedBaseMapLayer,
  selectedLayerTypes: getSelectedLayers(state),
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  updateSelectedBaseMapLayer: (selectedBaseMapLayer) =>
    dispatch(updateSelectedBaseMapLayer(selectedBaseMapLayer)),
  updateSelectedLayerTypes: (selectedLayerTypes) =>
    dispatch(updateSelectedLayerTypes(selectedLayerTypes)),
  dispatchSetMapOptions: () => dispatch(setMapOptions({})),
});

export default connect(mapStateToProps, mapDispatchToProps)(MapSettingsPage);
